export enum GroupUserStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const GroupUserStatusOptions = [
  {
    label: "Active",
    value: GroupUserStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: GroupUserStatus.INACTIVE,
  },
];
